import { Order } from '../models';
import { useDocument } from './useDocument';

export function useOrder(id: string) {
  return useDocument<Order>('Orders', id);
}
